import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingScreen from "src/components/LoadingScreen";
import arkadu from "src/coreConfig";
import useAsyncRequest from "src/hooks/useAsyncRequest";
import useTaxes from "src/hooks/useTaxes";
import useWebSocket from "src/hooks/useWebSocket";
import { setCustomerPeriods } from "src/slices/customers";
import { setCurrentLicense, setUpdatedTaxes } from "src/slices/taxes";
import { useDispatch, useSelector } from "src/store";
import ErrorView from "src/views/errors/ErrorView";

const TaxesContext = createContext();

const TaxesLayout = ({ children, ...rest }) => {
  const {
    licenses,
    currentLicense,
    liquorActivities,
    currentCustomerClassifier,
    licenseProcedures,
  } = useSelector((state) => state.taxes);
  const { currentCustomer, periods } = useSelector((state) => state.customers);
  const { adminMode } = useSelector((state) => state.settings);
  const [lastMode, setLastMode] = useState(null);
  const { t } = useTranslation();
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const { getTaxesConfig } = useTaxes();
  const [fetchRequests, setFetchRequests] = useState([]);
  const requestTypes = {
    license: "license_detail",
    license_declarations: "license_declarations",
    license_search: "license_search",
  };

  const [initialRequested, setInitialRequested] = useState(false);
  const { sendWs, ws, wsOnline, wsMessages, lastMessage } = useWebSocket(
    arkadu.urls.webSocket.taxes,
  );

  const { api } = useAsyncRequest();

  const refreshTaxes = () => {
    if (ws && ws.current && wsOnline && currentCustomer) {
      sendWs(
        JSON.stringify({
          type: "tax_request",
          message: {
            type: "refresh_taxes",
            customer_id: currentCustomer.id,
            mode: adminMode ? "admin" : "user",
          },
        }),
      );
    }
  };

  useEffect(() => {
    // sendWs(JSON.stringify({
    //     type: "tax_request",
    //     message: {
    //         type: requestTypes[r.itemName],
    //         id: r.itemId,
    //         customer_id: currentCustomer.id,
    //         mode: adminMode ? 'admin': 'user'
    //     }
    // }));
    // if(ws && ws.current && wsOnline ) {
    //     if(fetchRequests.length > 0) {
    //         var fR = fetchRequests;
    //         var processed = [];
    //         fR.forEach((r, i) => {
    //             try {
    //                 ws.current.send(JSON.stringify({
    //                     type: "tax_request",
    //                     message: {
    //                         type: requestTypes[r.itemName],
    //                         id: r.itemId,
    //                         customer_id: currentCustomer.id,
    //                         mode: adminMode ? 'admin': 'user'
    //                     }
    //                 }));
    //                 processed.push(i);
    //             } catch (e) {
    //             }
    //         });
    //         setFetchRequests(prevState => (_.map((f,id ) => {
    //             if(!processed.includes(id)) {
    //                 return f;
    //             }
    //         })));
    //     }
    // }
  }, [ws, wsOnline, fetchRequests]);

  const fetchTaxesItem = ({ itemName, itemId }) => {
    var msg = JSON.stringify({
      type: "tax_request",
      message: {
        type: requestTypes[itemName] || itemName,
        id: itemId,
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
    });
    sendWs(msg);
    // setFetchRequests(prevState => (_.concat(prevState, [{itemName, itemId}])));
  };
  useEffect(() => {
    if (!periods && currentCustomer && currentCustomer.periods) {
      dispatch(setCustomerPeriods(currentCustomer.periods));
    }
  }, [currentCustomer, periods]);

  useEffect(() => {
    if (currentCustomer && !currentCustomerClassifier) {
      // getClassifier();
      getTaxesConfig();
    }
  }, [currentCustomerClassifier, currentCustomer]);

  // useEffect(() => {
  //     if (currentCustomer && !licenses && !initialRequested) {
  //         setInitialRequested(true);
  //         getLicenses();
  //     }
  // }, [currentCustomer, licenses]);
  // useEffect(() => {
  //     if (ws && ws.current && wsOnline && currentCustomer && !licenses) {
  //         refreshTaxes();
  //     }
  // }, [ws, wsOnline, currentCustomer]);

  useEffect(() => {
    if (lastMode === null) {
      setLastMode(adminMode);
    } else {
      if (lastMode !== adminMode) {
        setLastMode(adminMode);

        if (ws && ws.current && wsOnline && currentCustomer) {
          refreshTaxes();
        }
      }
    }
  }, [adminMode]);

  useEffect(() => {
    if (lastMessage && lastMessage.type) {
      switch (lastMessage.type) {
        case "tax_error":
          setError(lastMessage.description);
          break;
        case "taxes_updated":
          dispatch(setUpdatedTaxes(lastMessage));
          break;
        case "license_detailed":
          dispatch(setCurrentLicense(lastMessage.data));
          break;
      }
    }
  }, [lastMessage]);

  if (!currentCustomer && !currentCustomerClassifier) {
    return <LoadingScreen message={t("cargando componentes...")} />;
  }
  if (error) {
    return <ErrorView message={error} />;
  }

  return (
    <TaxesContext.Provider value={{ ws, wsOnline, fetchTaxesItem }}>
      {children}
    </TaxesContext.Provider>
  );
};
export { TaxesContext };
export default TaxesLayout;
